module.exports = __webpack_public_path__ + "static/img/ios_ig.247d0906.png";